<template>
  <Scatter
      id="studentPerformanceChart"
      :options="chartOptions"
      :data="chartData"
  />
</template>

<script setup>
import {defineExpose, ref} from 'vue';
import {Scatter} from 'vue-chartjs';

import {Chart as ChartJS, LinearScale, LineElement, PointElement} from 'chart.js'

ChartJS.register(LinearScale, PointElement, LineElement)

const chartData = ref({
  datasets: []
})

const chartOptions = ref({
  responsive: true,
  aspectRatio: 1 / 0.9,
  plugins: {
    tooltip: {
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      callbacks: {
        label: function (context) {
          return ` Acurácia: ${context.parsed.x} | Velocidade: ${context.parsed.y}`;
        },
        title: function (context) {
          return context.map(c => c.raw.student).join(", ");
        }
      }
    }
  },
  elements: {
    point: {
      radius: 5
    }
  },
  scales: {
    y: {
      position: 'center',
      min: -10,
      max: 10,
      ticks: {
        stepSize: 2,
        maxTicksLimit: 20,
      }
    },
    x: {
      position: 'center',
      min: -10,
      max: 10,
      ticks: {
        stepSize: 2,
        maxTicksLimit: 20,
      }
    },
  }
})

function pointBackgroundColor(context) {
  const index = context.dataIndex;
  const student = context.dataset.data[index];
  if (!student) {
    return;
  }

  if (student.x < 0 && student.y < 0) {
    return 'rgb(240, 48, 10)';
  } else if ((student.x < 0 && student.y > 0) || (student.x > 0 && student.y < 0)) {
    return 'rgb(232, 196, 16)';
  } else if (student.x > 0 && student.y > 0) {
    return 'rgb(33, 184, 22)';
  }
}

const updateData = (performanceDistributionPerStudent) => {
  if (!performanceDistributionPerStudent) {
    return;
  }

  chartData.value = {
    datasets: [{
      label: 'Aluno',
      data: performanceDistributionPerStudent.map(student => {
            return {
              student: student.name,
              x: student.accuracy,
              y: student.speed
            }
          }
      ),
      pointBackgroundColor: pointBackgroundColor
    }]
  }
};

defineExpose({
  updateData
})
</script>

<style scoped>

</style>
